import React from 'react';
import { useSlateStatic } from 'slate-react';

import { InlineItem } from './InlineItem';
import { QuizItemsModal } from './QuizItemsModal';
import { useAulaEditorContext } from '../../EditorContext';
import { removeVoidElement } from '../../lib/commands';

import { AulaEntity, QuizEntity } from '../../Entities';
import { quizType } from '../../plugins/quiz/quizType';
import { BlockElement } from '../../types';

export type QuizProps = {
  element: BlockElement;
};

export const isQuizEntity = (entity: AulaEntity): entity is QuizEntity =>
  entity?.type === quizType;

export const Quiz: React.FunctionComponent<QuizProps> = ({ element }) => {
  const { entities } = useAulaEditorContext();
  const editor = useSlateStatic();

  const { entity: entityId } = element;
  const entity = entities[entityId];
  if (!isQuizEntity(entity)) {
    return null;
  }

  const onDeleteItem = () => {
    removeVoidElement(editor, element);
  };

  const { data } = entity;
  if (!data.item) {
    return <QuizItemsModal entityId={entityId} onDeleteItem={onDeleteItem} />;
  }

  const { item } = data;
  const referenceId = item.reference;

  return <InlineItem referenceId={referenceId} onDeleteItem={onDeleteItem} />;
};
